import React from 'react';
import { Select } from '@material-ui/core';
import { useStyles } from './styles';
import { IOptionData } from 'interfaces/utils';
import { GridFilterInputValueProps } from '@material-ui/data-grid';

const list = [
  { label: 'Todas', value: 'all' },
  { label: 'Rascunho', value: 'draft' },
  { label: 'Inativa', value: 'inactive' },
  { label: 'Ativa', value: 'active' },
  { label: 'Criada', value: 'created' },
] as IOptionData[];

const StatusFilterHeader = (props: GridFilterInputValueProps): JSX.Element => {
  const classes = useStyles();
  const { item: propsItem, applyValue } = props;

  const handleFilterChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const target = event.target as HTMLSelectElement;
    applyValue({ ...propsItem, value: target.value });
  };

  return (
    <Select
      native
      onChange={handleFilterChange}
      value={propsItem.value || 'all'}
    >
      {list.map((item) => (
        <option
          key={item.value}
          value={item.value}
          className={
            (!propsItem.value && item.value === 'all') ||
            propsItem.value === item.value
              ? classes.filterSelected
              : ''
          }
        >
          {item.label}
        </option>
      ))}
    </Select>
  );
};

export default StatusFilterHeader;
